export default __webpack_public_path__ + "static/media/campfire.8ed70576.svg";